import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { records } from "../data/RecordsData";
import "../styles/pages/Records.css";


export default function Records() {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    species: "",
    type: "",
    technique: "",
    location: "",
  });

  // Unique values for dropdowns
  const unique = (key) =>
    [...new Set(records.map((r) => r[key]).filter((v) => v && v !== "\u2014"))].sort();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const filtered = records.filter((r) =>
    Object.entries(filters).every(([key, val]) =>
      val ? r[key].toLowerCase().includes(val.toLowerCase()) : true
    )
  );

  return (
    <div className="fishipedia-page">
      

      <h1>{t("records_title")}</h1>
      <p style={{ color: "#555" }}>
        {t("records_intro")}
      </p>

      {/* === Filter Controls === */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 15 }}>
        <select name="species" value={filters.species} onChange={handleChange}>
          <option value="">{t("records_all_species")}</option>
          {unique("species").map((v) => (
            <option key={v}>{v}</option>
          ))}
        </select>

        <select name="type" value={filters.type} onChange={handleChange}>
          <option value="">{t("records_all_types")}</option>
          {unique("type").map((v) => (
            <option key={v}>{v}</option>
          ))}
        </select>

        <select name="technique" value={filters.technique} onChange={handleChange}>
          <option value="">{t("records_all_techniques")}</option>
          {unique("technique").map((v) => (
            <option key={v}>{v}</option>
          ))}
        </select>

        <select name="location" value={filters.location} onChange={handleChange}>
          <option value="">{t("records_all_locations")}</option>
          {unique("location").map((v) => (
            <option key={v}>{v}</option>
          ))}
        </select>

        <button
          onClick={() =>
            setFilters({ species: "", type: "", technique: "", location: "" })
          }
          style={{
            background: "#eee",
            border: "1px solid #ccc",
            borderRadius: 6,
            padding: "6px 12px",
            cursor: "pointer",
          }}
        >
          {t("records_reset_filters")}
        </button>
      </div>

      {/* === Data Table === */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: 15,
          fontSize: 15,
        }}
      >
        <thead style={{ background: "#e9f5fc" }}>
          <tr>
            <th>{t("records_column_species")}</th>
            <th>{t("records_column_weight")}</th>
            <th>{t("records_column_length")}</th>
            <th>{t("records_column_type")}</th>
            <th>{t("records_column_technique")}</th>
            <th>{t("records_column_location")}</th>
            <th>{t("records_column_date")}</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((r, i) => (
            <tr key={i} style={{ background: i % 2 ? "#f9f9f9" : "#fff" }}>
              <td>{r.species}</td>
              <td>{r.weight}</td>
              <td>{r.length}</td>
              <td>{r.type}</td>
              <td>{r.technique}</td>
              <td>{r.location}</td>
              <td>{r.date}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {filtered.length === 0 && (
        <p style={{ marginTop: 20, color: "#777" }}>{t("records_no_matches")}</p>
      )}
    </div>
  );
}
